<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">FAQ ({{ faqs.length || 0 }})</h5>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="onClickAddNewFAQ"
              >
                +
              </button>
            </div>

            <div class="empty" v-if="faqs.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped custom-table" v-else>
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Question</th>
                  <th scope="col">Answer</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="faq.id" v-for="faq in faqs">
                  <th scope="row">{{ faq.id }}</th>
                  <td>
                    {{ moment(faq.createdAt).format("YYYY/MM/DD HH:mm ") }}
                  </td>
                  <td>{{ faq.question || "--" }}</td>
                  <td>{{ faq.answer || "--" }}</td>
                  <td style="display: grid; gap: 10px">
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      @click="onClickDeleteFAQ(faq)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <create-faq-component
        v-if="showFAQCreationComponent"
        @success="faqCreationSuccess"
        @cancel="faqCreationCancelled"
      ></create-faq-component>

      <delete-item-modal
        :schemtics="faqDeleteSchemetics"
        v-if="showDeleteFAQModal"
        @success="onFAQDeleteSuccess"
        @cancel="onFAQDeleteCancelled"
      ></delete-item-modal>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
var NotificationsController = require("../components/NotificationsController.js");
import CreateFAQComponent from "../components/CreateFAQComponent.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";
import moment from "moment";
export default {
  name: "FAQ",
  components: {
    NavBar,
    "create-faq-component": CreateFAQComponent,
    DeleteItemModal,
  },
  data() {
    return {
      faqs: [],
      showFAQCreationComponent: false,
      faqDeleteSchemetics: {},
      showDeleteFAQModal: false,
    };
  },
  methods: {
    onFAQDeleteCancelled() {
      this.showDeleteFAQModal = false;
      this.faqDeleteSchemetics = {};
    },
    onFAQDeleteSuccess() {
      this.showDeleteFAQModal = false;
      this.faqDeleteSchemetics = {};
      this.getFAQs();
    },
    onClickDeleteFAQ(faq) {
      let access_level = localStorage.getItem("access_level");
      if (access_level != 1) {
        this.$toast.error("Only faq with access level 1 can delete other faqs");
        return;
      }
      let url = URLS.FAQ.BY_ID.replace(":id", faq.id);
      this.faqDeleteSchemetics = {
        endpoint: url,
        title: "Delete FAQ",
        description: `Are you sure you want to delete <b> "${faq.question}" </b> from the faqs list ?`,
      };
      this.showDeleteFAQModal = true;
    },
    onClickAddNewFAQ() {
      this.showFAQCreationComponent = true;
    },
    faqCreationSuccess(res) {
      this.showFAQCreationComponent = false;
      this.getFAQs();
    },
    faqCreationCancelled() {
      this.showFAQCreationComponent = false;
    },
    getFAQs() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.FAQ.LIST;
      HTTP.get(url)
        .then((response) => {
          let rows = response.data;
          ctx.faqs = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getFAQs();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.preview {
  width: 8rem;
  height: 4.5rem;
}
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    button {
      height: 3rem;
      font-size: 2rem;
      text-align: center;
      line-height: 1rem;
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;

  .input-group {
    display: flex;
    align-items: center;

    div {
      height: 100% !important;
    }

    input {
      height: 100% !important;
    }
  }

  .actions {
    margin-left: auto;
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    button {
      widows: 100px;
    }
  }
  // button{
  //   margin-left: 10px;
  // }
}
.actions {
  button {
    margin-right: 4px;
  }
}
</style>
